import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/sass/app.scss';
import * as VueCore from 'vue/dist/vue.esm-bundler.js';
import { tarefasEnvolveService } from './service/tarefas-envolve-service'
import { selectOverflowDirective } from './directives/select-overflow.js'
import { cookieUtils } from '../src/util/cookie.utils';
import { acessoUtils } from '../src/util/acesso.utils';
import { servidorUtils } from './util/servidor.utils.js';
import { layoutStore } from './stateManagement/layout';
import { ve2e } from './directives/e2e';
import { Authenticator } from './stateManagement/authenticator';

window.Vue = VueCore
window.tarefasUtil = {
    isProd: process.env.NODE_ENV === 'production'
}
const MONITORING_ENVS = ['econtador-prod'];

function _importarComponenteNavbar(baseUrl = 'http://localhost:5000/') {
    const navbarScript = document.createElement('script');
    navbarScript.setAttribute('type', 'module');
    navbarScript.setAttribute('src', `${baseUrl}components/wc-navbar.js`);
    document.head.appendChild(navbarScript)
}
function _importarComponenteMenu(baseUrl = 'http://localhost:5000/') {
    const menuScript = document.createElement('script');
    menuScript.setAttribute('type', 'module');
    menuScript.setAttribute('src', `${baseUrl}components/wc-menu.js`);
    document.head.appendChild(menuScript)
}

async function isOpenRoute() {
    const pathname = window.location.pathname;
    return router.options.routes.some(route => route.meta?.openRoute && pathname.includes(route.path));
}

async function isAuthenticated() {
    return await Authenticator.getIsAuthenticated();
}

function _instrumentar_rum() {
    if(!MONITORING_ENVS.includes(process.env.VUE_APP_DATADOG_ENV)) return;

    (function(h,o,u,n,d) {
        h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
        d=o.createElement(u);d.async=1;d.src=n
        n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
    })(window,document,'script','https://www.datadoghq-browser-agent.com/us1/v5/datadog-rum.js','DD_RUM')
    window.DD_RUM.onReady(function() {
        window.DD_RUM.init({
        clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN,
        applicationId: process.env.VUE_APP_DATADOG_APPLICATION_ID,
        site: 'datadoghq.com',
        service: 'wa-tarefas',
        env: `${process.env.VUE_APP_DATADOG_ENV}`,
        version: `${process.env.VUE_APP_VERSION}`,
        allowedTracingUrls: [(url) => url.startsWith(`${process.env.VUE_APP_MS_URL}`)],
        traceSampleRate: Number(process.env.VUE_APP_DATADOG_TRACE_SAMPLE_RATE),
        sessionSampleRate: Number(process.env.VUE_APP_DATADOG_SESSION_SAMPLE_RATE),
        sessionReplaySampleRate: Number(process.env.VUE_APP_DATADOG_SESSION_REPLAY_SAMPLE_RATE),
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        });
        const crm = acessoUtils.adquirirCRMDoUsuarioLogado();
        if (crm) {
            window.DD_RUM.setGlobalContextProperty('crm', crm);
        }
    })
}

async function mountApp() {
    const isServidorEmManutencao = servidorUtils.isServidorEmManutencao();
    
    layoutStore.verificaresolucaoTouch();
    window.addEventListener('resize', () => layoutStore.verificaresolucaoTouch());
    const app = createApp(App).use(router);
    app.directive('select-overflow', selectOverflowDirective)
    app.directive('e2e', ve2e)
    app.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("wc-");
    app.mount('#app');

    const rotaAberta = await isOpenRoute();
    
    // Só podemos bater na verificação de autenticação se a
    // rota não for aberta pois a falha nos requests redireciona o acesso.
    if (rotaAberta || await isAuthenticated()) {
        _instrumentar_rum();
    }

    if(isServidorEmManutencao) {
        return;
    }
    
    if (cookieUtils.verificarCookie(`primeiro-acesso-tarefas-web-${JSON.stringify(acessoUtils.adquirirCRMDoUsuarioLogado())}`)) {
        tarefasEnvolveService.getEnvolve();
    }
}

_importarComponenteMenu(process.env.VUE_APP_WC_ECONTADORMENU);
_importarComponenteNavbar(process.env.VUE_APP_WC_ECONTADORMENU);
mountApp();